import { useState } from "react";
import { useTranslation } from "react-i18next";

import { WorkdayMeetingsSection } from "../WorkdaySections";
import { LocalDateString } from "@lib/store/src/data/timeslots/apiTypes";
import { getMeetingsOutsideOfWorkdays, useAppSelector, useOverridableFeatureFlags } from "@lib/store";
import { WorkdayHeaderTitle } from "../WorkdayTileHeader";
import { CalendarEventCell } from "@organisms";
import { WorkdayIcon } from "@molecules";

interface WorkdayMeetingsTileProps {
  selectedDate: LocalDateString;
}

export const WorkdayMeetingsTile = ({ selectedDate }: WorkdayMeetingsTileProps) => {
  const { t } = useTranslation();
  const [isMeetingListVisible, setIsMeetingListVisible] = useState(false);

  const features = useOverridableFeatureFlags();
  const meetingsOutsideOfWorkdays = useAppSelector(state => getMeetingsOutsideOfWorkdays(state, selectedDate));

  if (!features.HybridMeetingsCalendarView) return null;

  return (
    <div className="w-full rounded-xl border border-gray-200 bg-beige-200 p-4">
      <div className="flex items-center gap-3 mb-2 p-1.5">
        <WorkdayIcon
          status="Unknown"
          className="bg-energizing-yellow-500*"
        />

        <div>
          <WorkdayHeaderTitle title={t("meeting:LocationUnknown")} />
        </div>
      </div>

      <WorkdayMeetingsSection
        selectedDate={selectedDate}
        handleClassName="bg-white border-b-0 rounded-xl"
        isUnknownLocation
        onPress={() => setIsMeetingListVisible(prev => !prev)}
      />

      {isMeetingListVisible && (
        <div className="mt-4 space-y-4">
          {meetingsOutsideOfWorkdays.map(meeting => (
            <CalendarEventCell
              key={meeting.id}
              meeting={meeting}
              date={selectedDate}
            />
          ))}
        </div>
      )}
    </div>
  );
};
